import script from "./LibIcon.vue?vue&type=script&setup=true&lang=ts"
export * from "./LibIcon.vue?vue&type=script&setup=true&lang=ts"

import "./LibIcon.vue?vue&type=style&index=0&id=3d804484&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d804484"]])

export default __exports__